import React from 'react';
import { Lock } from 'lucide-react';

interface ProLockOverlayProps {
  variant: 'modal' | 'inline-overlay';
  title?: React.ReactNode;
  description?: string;
  onUpgrade?: () => void;
  onDismiss?: () => void;
}

export const ProLockOverlay: React.FC<ProLockOverlayProps> = ({
  variant,
  title = 'Proプランの機能です',
  description = 'この機能はProプラン以上でご利用いただけます。',
  onUpgrade,
  onDismiss,
}) => {
  const card = (
    <div
      style={{
        background: '#fff',
        borderRadius: '20px',
        width: '100%',
        maxWidth: '440px',
        padding: '40px 32px',
        textAlign: 'center',
        boxShadow: variant === 'modal' ? '0 20px 50px rgba(15,23,42,0.25)' : '0 4px 24px rgba(15,23,42,0.12)',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* ロックアイコン */}
      <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#E0F2F1', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
        <Lock size={28} color="#0a7a72" strokeWidth={2} />
      </div>
      {/* タイトル */}
      <div style={{ fontSize: '20px', fontWeight: 700, color: '#0F172A', marginBottom: '12px', lineHeight: 1.4 }}>
        {title}
      </div>
      {/* 説明 */}
      <div style={{ fontSize: '14px', color: '#64748B', lineHeight: 1.75, marginBottom: '28px' }}>
        {description}
      </div>
      {/* CTAボタン */}
      <button
        type="button"
        data-testid={variant === 'modal' ? 'modal-pro-upsell-cta' : 'lead-pro-lock-cta'}
        onClick={onUpgrade}
        style={{ background: '#0a7a72', color: '#fff', border: 'none', borderRadius: '10px', padding: '14px 28px', fontSize: '16px', fontWeight: 700, width: '100%', cursor: 'pointer', marginBottom: '16px' }}
      >
        Proにアップグレード
      </button>
      {/* dismissボタン */}
      {onDismiss && (
        <button
          type="button"
          data-testid={variant === 'modal' ? 'modal-pro-upsell-dismiss' : 'lead-pro-lock-dismiss'}
          onClick={onDismiss}
          style={{ background: 'none', border: 'none', color: '#94A3B8', fontSize: '14px', cursor: 'pointer', padding: '4px 0' }}
        >
          あとで
        </button>
      )}
    </div>
  );

  if (variant === 'modal') {
    return (
      <div
        data-testid="modal-pro-upsell"
        style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', zIndex: 50 }}
        onClick={onDismiss}
      >
        {card}
      </div>
    );
  }

  return (
    <div
      data-testid="lead-pro-lock"
      style={{ position: 'absolute', inset: 0, backdropFilter: 'blur(4px)', background: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', zIndex: 10 }}
    >
      {card}
    </div>
  );
};
